"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsClientV2 = void 0;
const tslib_1 = require("tslib");
const client_error_1 = require("../errors/client.error");
const authenticated_client_1 = require("./authenticated.client");
const to_date_time_string_1 = require("./utils/to-date-time-string");
const settings_1 = require("../settings");
class MetricsClientV2 extends authenticated_client_1.AuthenticatedClient {
    constructor(settings = settings_1.DefaultClientSettings) {
        super(settings);
        this.settings = settings;
        this.executor.setFormatDateWithTimezone(true);
    }
    getMetrics(projectId, body) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/metrics`, body);
            return response.payload;
        });
    }
    getChart(projectId, body) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/metrics/chart`, body);
            return response.payload;
        });
    }
    getSiteOverviewMetrics(ac) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${ac.project}/metrics/site-overview`;
            const body = {
                from: ac.from,
                to: ac.to,
                goal: ac.goal,
                segment: ac.segment,
                device: ac.device,
                toCurrency: ac.toCurrency,
            };
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getImpactMetrics(ac) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${ac.project}/metrics/impact`;
            const body = {
                from: ac.from,
                to: ac.to,
                goal: ac.goal,
                segment: ac.segment,
                device: ac.device,
                toCurrency: ac.toCurrency,
            };
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getExposures(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { project } = request, body = tslib_1.__rest(request, ["project"]);
            const url = `/v2/projects/${project}/metrics/exposures`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getZoningMetrics(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { project } = request, body = tslib_1.__rest(request, ["project"]);
            const url = `/v2/projects/${project}/metrics/zoning`;
            const response = yield this.httpPost(url, body);
            return response.payload || [];
        });
    }
    getZonesMetrics(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = Array.isArray(request.metrics) ? { metrics: request.metrics } : { metricType: request.metrics };
            const url = `/v2/projects/${request.project}/metrics/zones?` + this.getQueryString(queryString);
            const response = yield this.httpPost(url, Object.assign(Object.assign({}, request), { metrics: undefined }));
            return response.payload;
        });
    }
    getZonesVersionedMetrics(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = Array.isArray(request.metrics) ? { metrics: request.metrics } : { metricType: request.metrics };
            const url = `/v2/projects/${request.project}/metrics/zones-versioned?` + this.getQueryString(queryString);
            const response = yield this.httpPost(url, Object.assign(Object.assign({}, request), { metrics: undefined }));
            return response.payload;
        });
    }
    getPageViews(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { project } = request, body = tslib_1.__rest(request, ["project"]);
            const url = `/v2/projects/${project}/metrics/total-views`;
            const response = yield this.httpPost(url, body);
            return {
                pageId: request.pageId || request.aliasId,
                urlRegex: request.urlRegex,
                totalViews: response.payload ? response.payload.totalViews : null,
            };
        });
    }
    getPageMetrics(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { project } = request, body = tslib_1.__rest(request, ["project"]);
            const url = `/v2/projects/${request.project}/metrics/page`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getPagesMetrics(ac) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${ac.project}/metrics/pages`;
            const body = {
                from: ac.from,
                to: ac.to,
                goal: ac.goal,
                segment: ac.segment,
                device: ac.device,
                metrics: ac.metrics,
                pages: ac.pages,
                urlRegexes: ac.urlRegexes,
            };
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getFoldHeight(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { project } = request, body = tslib_1.__rest(request, ["project"]);
            const url = `/v2/projects/${request.project}/metrics/foldheight`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getNavigationTree(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { project } = request, body = tslib_1.__rest(request, ["project"]);
            const url = `/v2/projects/${request.project}/metrics/navigation-path`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getFunnelMetrics(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { project } = request, body = tslib_1.__rest(request, ["project"]);
            const url = `/v2/projects/${request.project}/metrics/funnel-metrics`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getStats(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `/v2/projects/${projectId}/segments/stats`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getTraffic(projectId, segment, from, to) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/segments/traffic`;
            const response = yield this.httpPost(url, { from, to, segment });
            return response.payload;
        });
    }
    getTrafficDistributionV2(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `/v2/projects/${projectId}/metrics/traffic/distributionV2`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getDevicesDistribution(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = tslib_1.__rest(request, ["projectId"]);
            const url = `/v2/projects/${projectId}/metrics/devices/traffic`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getMissToWinV2(missToWinModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${missToWinModel.project}/segments/misstowinV2`, missToWinModel);
            if (!response) {
                throw new client_error_1.ClientError({
                    success: false,
                    errorMessage: 'ERROR_CODE: 001',
                    errorCode: '400',
                });
            }
            return response.payload;
        });
    }
    getFormStats(projectId, segments, from, to, device) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/segments/form-stats`;
            const response = yield this.httpPost(url, {
                from: (0, to_date_time_string_1.toDateTimeString)(from),
                to: (0, to_date_time_string_1.toDateTimeString)(to),
                device,
                segments,
            });
            return response.payload;
        });
    }
}
exports.MetricsClientV2 = MetricsClientV2;
//# sourceMappingURL=metrics.client.v2.js.map